<template>
  <table class="table table-bordered">
    <thead>
      <tr>
        <th>Name</th>
        <th>Email</th>
        <th></th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="user in users">
        <td>{{ user.name }}</td>
        <td>{{ user.email }}</td>
        <td><button type="button" class="btn btn-sm btn-secondary" @click="resetPass(user)">Reset password</button></td>
      </tr>
    </tbody>

  </table>
</template>


<script>
import userService from '../../services/userService'

export default {
  props: ['users'],
  methods: {
    resetPass(user) {
      if (confirm('Are you sure you want to reset the password of client ' + user.name + '?')) {
        userService.sendMailForNewPass(user.email)
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-service-app/components/tables/UsersTable.vue